import LoginPage from '@/features/login/page'
import { createFileRoute } from '@tanstack/react-router'

type LoginSearchParams = {
  invitationId?: string
}

export const Route = createFileRoute('/login/')({
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => ({
    invitationId: typeof search.invitationId === 'string' ? search.invitationId : undefined,
  }),
})
